<template>
  <div>
    <!-- 导航栏 -->
    <Navbar />

    <!-- 登录表单 -->
    <div class="box">
      <div class="title">用户登录</div>
      <input v-model="userName" placeholder="请输入用户名" />
      <input v-model="password" type="password" placeholder="请输入密码" />
      <button class="loginbutton" @click="doLogin">登录</button>
      <div class="link">忘记密码？<span @click="$router.push('/register')">找回</span></div>
      <div class="link">没有账号？<span @click="$router.push('/register')">立即注册</span></div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import { Toast } from 'vant'

export default {
  name: 'Login',
  components: { Navbar },
  data() {
    return {
      userName: '',
      password: ''
    }
  },
  methods: {
    async doLogin() {
      if (!this.userName || !this.password) {
        Toast('请输入用户名和密码')
        return
      }
      try {
        const params = new URLSearchParams()
        params.append('username', this.userName)
        params.append('password', this.password)
        const res = await this.$axios.post('https://test2.taila.club/api/login.php', params, {
          timeout: 10000,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        if (res.data.code === 200) {
          localStorage.setItem('token', res.data.token)
          Toast('登录成功')
          this.$router.push('/')
        } else {
          Toast(res.data.msg || '登录失败')
        }
      } catch (e) {
        Toast('网络错误，请重试')
      }
    }
  }
}
</script>

<style scoped>
.box {
  max-width: 400px;
  margin: 80px auto;
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 20px rgba(0,0,0,0.08);
}
.title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 30px;
  font-weight: bold;
  color: #333;
}
input {
  width: 100%;
  padding: 12px 15px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s;
}
input:focus { border-color: #1989fa; }
.loginbutton {
  width: 100%;
  padding: 12px;
  background: #1989fa;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  margin-top: 10px;
  cursor: pointer;
  transition: opacity 0.3s;
}
.loginbutton:hover { opacity: 0.9; }
.link {
  text-align: center;
  margin-top: 15px;
  color: #666;
  font-size: 14px;
}
.link span {
  color: #1989fa;
  cursor: pointer;
}
</style>
